export class FindProjectOrganisationProjectRoleAction {
  public static readonly type =
    '[Authorisation] FindProjectOrganisationProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly projectId: string,
  ) {}
}
